import { ROUTE_AVAILABILITY_GROUPS_DETAILS } from '@/constants/routes';
import IResourceGroup from '@/types/IResourceGroup';
import {
	ButtonGroup,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Flex,
	FormControl,
	FormLabel,
	IconButton,
	Select,
	Tag,
	TagLabel,
	Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiEdit, FiTrash } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

interface IGroupProps {
	resourceGroup: IResourceGroup;
	/**
	 * Numbe of people required from this group.
	 */
	min: number;
	onRemoveClick: () => void;
}

export function Group(props: IGroupProps) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Card mt={1} size="sm" overflow="hidden" as="details" shadow="none" borderWidth={1} borderColor="gray.200">
			<CardHeader
				_hover={{
					bg: 'gray.50',
				}}
				overflow="hidden"
				as="summary"
				display="grid"
				gridTemplateColumns="auto 1fr auto"
				alignItems="center"
			>
				<Tag mr={2} size="sm">
					{props.min}
				</Tag>
				<Text overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontWeight={500}>
					{props.resourceGroup.name}
				</Text>
				<ButtonGroup isAttached variant="ghost" size="xs">
					<IconButton
						icon={<FiEdit />}
						aria-label={t('Edit')}
						onClick={() => {
							history.push(ROUTE_AVAILABILITY_GROUPS_DETAILS.replace(':id', props.resourceGroup.id));
						}}
					/>
					<IconButton icon={<FiTrash />} aria-label="Delete" onClick={props.onRemoveClick} />
				</ButtonGroup>
			</CardHeader>
			<CardBody>
				<Text fontWeight={500}>
					{t('Members on this group')} ({props.resourceGroup.resources.length})
				</Text>

				<Flex mt={2} gap={2} flexWrap="wrap">
					{props.resourceGroup.resources.map((r) => {
						return (
							<Tag size="lg" colorScheme="green" borderRadius="lg" key={r.id}>
								<TagLabel>{r.name}</TagLabel>
							</Tag>
						);
					})}
				</Flex>
			</CardBody>
			<CardFooter>
				<FormControl size="xs">
					<FormLabel>{t('Number of people required for the meetings')}</FormLabel>
					<Select>
						<option>1</option>
					</Select>
				</FormControl>
			</CardFooter>
		</Card>
	);
}
